import * as XLSX from 'xlsx'

export type ExportFormat = 'csv' | 'xlsx'

export interface ExportConfig {
  filename: string
  sheetName?: string
  format?: ExportFormat
}

// Generic export function
export const exportData = <T extends Record<string, unknown>>(data: T[], config: ExportConfig) => {
  const { filename, sheetName = 'Data', format = 'xlsx' } = config

  // Create a new workbook
  const wb = XLSX.utils.book_new()

  // Convert data to worksheet
  const ws = XLSX.utils.json_to_sheet(data)

  // Add worksheet to workbook
  XLSX.utils.book_append_sheet(wb, ws, sheetName)

  // Generate filename with current date
  const currentDate = new Date().toISOString().split('T')[0]
  const fullFilename = `${filename}_${currentDate}.${format}`

  // Export the file
  if (format === 'csv') {
    XLSX.writeFile(wb, fullFilename, { bookType: 'csv' })
  } else {
    XLSX.writeFile(wb, fullFilename, { bookType: 'xlsx' })
  }
}
